Vue.filter('round', function(value, decimals) {
    if(!value) {
        value = 0;
    }

    if(!decimals) {
        decimals = 0;
    }

    value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
    return value;
});

Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString().toLowerCase();
    return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('truncate', function (value, limit) {
    if (value && value.length > limit) {
        value = value.substring(0, (limit - 3)) + '...';
    }

    return value
});


// WEBPACK FOOTER //
// ./resources/assets/js/vue-filters.js